import React from 'react';
const UPLOADS = process.env.REACT_APP_API_URL || 'http://localhost:4000';

export default function Partenaires({ partners = [], settings = {}, sectionCfg = {}, content = {} }) {
  const theme = sectionCfg.bg?.startsWith('#') ? 'custom'
              : sectionCfg.theme || settings['theme.partenaires'] || 'light';
  const bg = sectionCfg.bg?.startsWith('#') ? sectionCfg.bg
           : theme === 'dark' ? (settings['color.primary'] || '#0A1628')
           : theme === 'blue' ? '#0D3B6E'
           : 'var(--color-bg)';
  const isDark = theme === 'dark' || theme === 'blue' || (sectionCfg.bg?.startsWith('#') && (() => {
    const h = sectionCfg.bg.replace('#','');
    const r=parseInt(h.slice(0,2),16); const g=parseInt(h.slice(2,4),16); const b=parseInt(h.slice(4,6),16);
    return (r*299+g*587+b*114)/1000 < 128;
  })());
  const label = content.label || '';
  const title = content.title || '';

  // Tripler pour un défilement plus fluide
  const tripled = [...partners, ...partners, ...partners];

  // Calculer la largeur totale approximative pour la durée de l'animation
  const cardWidth = 180; // largeur approximative d'une carte (160px + marges)
  const totalWidth = partners.length * cardWidth;
  const duration = Math.max(15, partners.length * 1.5); // Durée dynamique basée sur le nombre de logos

  return (
    <section id="partenaires" style={{ padding:'4rem 0', background: bg, overflow:'hidden' }}>
      <style>{`
        @keyframes marquee {
          0%   { transform: translateX(0); }
          100% { transform: translateX(-33.33%); }
        }
        
        .partners-container {
          position: relative;
          width: 100%;
          overflow: hidden;
          mask-image: linear-gradient(
            to right,
            transparent,
            black 5%,
            black 95%,
            transparent
          );
          -webkit-mask-image: linear-gradient(
            to right,
            transparent,
            black 5%,
            black 95%,
            transparent
          );
        }
        
        .partners-track {
          display: flex;
          animation: marquee ${duration}s linear infinite;
          width: max-content;
        }
        
        .partners-track:hover {
          animation-play-state: paused;
        }
        
        .partner-card {
          background: ${isDark ? 'rgba(255,255,255,0.06)' : '#fff'};
          border: 1px solid ${isDark ? 'rgba(255,255,255,0.12)' : 'var(--color-border)'};
          border-radius: 12px;
          padding: 1.2rem;
          text-align: center;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 0.75rem;
          width: 160px;
          flex-shrink: 0;
          margin: 0 0.75rem;
          transition: all 0.3s ease;
          backdrop-filter: ${isDark ? 'blur(10px)' : 'none'};
        }
        
        .partner-card:hover {
          border-color: var(--color-accent);
          transform: translateY(-4px);
          box-shadow: 0 8px 20px rgba(0, 0, 0, ${isDark ? '0.2' : '0.08'});
        }
        
        .partner-role {
          font-size: 9px;
          letter-spacing: 2px;
          text-transform: uppercase;
          color: ${isDark ? 'rgba(255,255,255,0.4)' : 'var(--color-text-light)'};
          line-height: 1.4;
          font-weight: 600;
        }
        
        .partner-logo-box {
          width: 100%;
          height: 60px;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
        }
        
        .partner-logo-box img {
          max-width: 100%;
          max-height: 100%;
          width: auto;
          height: auto;
          object-fit: contain;
          display: block;
          transition: transform 0.3s ease;
        }
        
        .partner-card:hover .partner-logo-box img {
          transform: scale(1.05);
        }
        
        .partner-logo-placeholder {
          width: 48px;
          height: 48px;
          border-radius: 50%;
          background: ${isDark ? 'rgba(255,255,255,0.08)' : 'var(--color-bg)'};
          border: 1px dashed ${isDark ? 'rgba(255,255,255,0.2)' : 'var(--color-border)'};
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 20px;
          font-weight: 600;
          color: ${isDark ? 'rgba(255,255,255,0.4)' : 'var(--color-text-light)'};
        }
        
        .partner-name {
          font-weight: 600;
          font-size: 12px;
          color: ${isDark ? 'rgba(255,255,255,0.8)' : 'var(--color-text)'};
          line-height: 1.3;
        }
        
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        .section-label, .section-title {
          animation: fadeIn 0.6s ease-out;
        }
        
        @media (max-width: 768px) {
          .partner-card {
            width: 140px;
            padding: 1rem;
            margin: 0 0.5rem;
          }
          
          .partner-logo-box {
            height: 50px;
          }
          
          .partner-name {
            font-size: 10px;
          }
          
          .partner-role {
            font-size: 8px;
          }
        }
        
        @media (max-width: 480px) {
          .partner-card {
            width: 120px;
            padding: 0.875rem;
          }
          
          .partner-logo-box {
            height: 40px;
          }
        }
      `}</style>

      <div className="section-inner" style={{ marginBottom: '2rem' }}>
        {label && (
          <div className="section-label" style={{ color: isDark ? 'rgba(255,255,255,0.5)' : 'var(--color-accent)' }}>
            {label}
          </div>
        )}
        {title && (
          <h2 className="section-title" style={{ marginBottom: '0', color: isDark ? '#fff' : undefined }}>
            {title}
          </h2>
        )}
      </div>

      {!partners.length ? (
        <div className="section-inner">
          <div style={{ color: 'var(--color-text-mid)', fontSize: 14, padding: '2rem', textAlign: 'center', border: '1px dashed var(--color-border)', borderRadius: 6 }}>
            Aucun partenaire configuré.
          </div>
        </div>
      ) : (
        <div className="partners-container">
          <div className="partners-track">
            {tripled.map((p, i) => (
              <div key={i} className="partner-card">
                <div className="partner-role">{p.role}</div>
                <div className="partner-logo-box">
                  {p.logo_path ? (
                    <img src={`${UPLOADS}${p.logo_path}`} alt={p.name} />
                  ) : (
                    <div className="partner-logo-placeholder">
                      {p.name.charAt(0)}
                    </div>
                  )}
                </div>
                <div className="partner-name">{p.name}</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </section>
  );
}